import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import { pagesReducer } from '../../app/modules/auth/redux/PagesRedux';

export const rootReducer = combineReducers({
  auth: auth.reducer,
  pages: pagesReducer
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
}
